module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-aure-wood-rovere-nordic-milled.ccd0f096.jpg";